
<script setup lang="ts">
const meta = {"title":"API","description":"API documentation","keywords":"api, vuetify"}
 const assets = undefined
 const backmatter = undefined
 const features = undefined
 const fluid = undefined
 const related = undefined
 const toc = []
  defineExpose({ frontmatter: {"meta":{"title":"API","description":"API documentation","keywords":"api, vuetify"},"toc":[]}, excerpt: undefined })
  
  const name = shallowRef('')

</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {"meta":{"title":"API","description":"API documentation","keywords":"api, vuetify"},"toc":[]}
export const excerpt: string | undefined = ""

</script>
<template>
<div>
<api-view v-on:update:name="name = $event">
<section id="name-api">
<app-heading href="#name-api" level="1">{{ name }} API</app-heading>
<page-features></page-features>
<api-backlinks :name="name"></api-backlinks>
<promoted-entry></promoted-entry>
<api-search></api-search>
</section>
</api-view>
</div>
</template>
